import { AddDevicesModule } from './add-devices/add-devices.module';
import { NotificationsModule } from './notifications/notifications.module';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import {
  LocationStrategy,
  HashLocationStrategy,
  registerLocaleData,
  CommonModule,
} from '@angular/common';
import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en';

registerLocaleData(localePl, 'pl');
registerLocaleData(localeEn, 'en');

import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';

import { MessageService } from 'primeng/components/common/messageservice';
import { AuthService } from './core/auth.service';
import {
  TranslateModule,
  TranslateLoader,
  TranslateCompiler,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import {
  MatButtonModule,
  MatExpansionModule,
  MatIconModule,
  MatMenuModule,
  MatToolbarModule,
} from '@angular/material';
import { AdminPanelService } from './admin-panel/admin-panel.service';
// @ts-ignore
import cacheBusting from '../../i18n-cache-busting.json';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { DevicesReportsModule } from './devices-reports/devices-reports.module';
import { DevicesSettingsModule } from './admin-panel/settings/devices-settings/devices-settings.module';
import { MainMenuComponent } from './core/main-menu/main-menu.component';
import { FooterComponent } from './core/footer/footer.component';
import { HamburgerMenuComponent } from './core/main-menu/hamburger-menu/hamburger-menu.component';
import { InstructionModule } from './instruction/instruction.module';

import { NotificationPermissionBannerModule } from './notification-permission-banner/notification-permission-banner.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    'assets/i18n/',
    `.json?v=${cacheBusting}`
  );
}

@NgModule({
  declarations: [
    AppComponent,
    AdminPanelComponent,
    MainMenuComponent,
    FooterComponent,
    HamburgerMenuComponent,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    MatExpansionModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    NotificationsModule,
    AddDevicesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: true,
    }),
    CoreModule,
    DevicesReportsModule,
    DevicesSettingsModule,
    InstructionModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    NotificationPermissionBannerModule
  ],
  providers: [
    MessageService,
    AdminPanelService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: LOCALE_ID,
      deps: [AuthService],
      useFactory: (authService) => authService.getLocale(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
